import { locationsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';
import { startCasePreserveSymbols } from 'utils/string';

export const COUNTIES_ACTION_TYPE = createNamedActions('counties', {
  GET_COUNTIES: 'GET_COUNTIES',
});

export const getLocationsCountiesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await locationsApi.getCounties();

  return dispatch({
    type: COUNTIES_ACTION_TYPE.GET_COUNTIES,
    payload: data.map(county => ({
      ...county,
      name: startCasePreserveSymbols(county.name),
      value: startCasePreserveSymbols(county.name),
    })),
  });
});
